import React, { useEffect, useState } from "react";
import {
  AddButton,
  CancelButton,
  SubmitButton,
  UpdateButton,
} from "../../../components/mui/Buttons/Buttons";
import { Form, FormikProvider, useFormik } from "formik";
import { Box, MenuItem, Select, Stack, TextField } from "@mui/material";
import GlobalDialog from "../../../components/mui/Dialogue/GlobalDialog";
import GlobalSelectField from "../../../components/mui/GlobalSelectField";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { updateCategory } from "../../../redux/features/assetManagementSlice";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  addCroRescheduledDate,
  getCroRescheduledData,
} from "../../../redux/features/croSlice";

const PostSchedule = ({ rowData, dispatchdata }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const [value, setValue] = useState(dayjs());

  const { loading } = useSelector((state) => state.cro);

  const ValidationSchema = Yup.object().shape({
    rescheduled_reason: Yup.string().required("Please add reason"),
    from_time: Yup.string().nullable().required("From time is required"),
    to_time: Yup.string().nullable().required("To time is required"),
    session_date: Yup.string().nullable().required("Date is required"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      rescheduled_reason: "",
      week_day: "",
      from_time: null,
      to_time: null,
      session_date: null,
      session_schedule_id: rowData.session_schedule_id,
    },
    validationSchema: ValidationSchema,
    onSubmit: (values) => {
      dispatch(addCroRescheduledDate(values)).then((res) => {
        console.log(res);
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
          dispatch(getCroRescheduledData(dispatchdata));
          setOpen(false);
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
          // setOpen(false);
        }
      });
    },
  });

  return (
    <GlobalDialog
      title={"Add Reschedule"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"md"}
      closeButton={true}
      popupButton={
        <AddButton
          disabled={rowData.rescheduled_date}
          size="medium"
          action={() => setOpen(true)}
        >
          Add Reschedule
        </AddButton>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"} spacing={2}>
                  <Stack
                    direction={{
                      xs: "column",
                      sm: "row",
                      md: "row",
                      lg: "row",
                      xl: "row",
                    }}
                    spacing={2}
                  >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Date"
                        value={formik.values.session_date}
                        onChange={(newValue) => {
                          const selectedDate = dayjs(newValue);
                          formik.setFieldValue(
                            "session_date",
                            selectedDate.format("YYYY-MM-DD")
                          );
                          formik.setFieldValue("week_day", selectedDate.day());
                        }}
                        format="YYYY-MM-DD"
                        minDate={dayjs()}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            error:
                              formik.touched.session_date &&
                              Boolean(formik.errors.session_date),
                            helperText:
                              formik.touched.session_date &&
                              formik.errors.session_date,
                            onKeyDown: (e) => e.preventDefault(),
                          },
                        }}
                      />
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        name="from_time"
                        label="From Time"
                        value={formik.values.from_time}
                        onChange={(newValue) => {
                          formik.setFieldValue(
                            "from_time",
                            dayjs(newValue).format("HH:mm:ss")
                          );
                        }}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            error:
                              formik.touched.from_time &&
                              Boolean(formik.errors.from_time),
                            helperText:
                              formik.touched.from_time &&
                              formik.errors.from_time,
                            onKeyDown: (e) => e.preventDefault(),
                          },
                        }}
                      />
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TimePicker
                        name="to_time"
                        label="To Time"
                        value={formik.values.to_time}
                        onChange={(newValue) => {
                          formik.setFieldValue(
                            "to_time",
                            dayjs(newValue).format("HH:mm:ss")
                          );
                        }}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            error:
                              formik.touched.to_time &&
                              Boolean(formik.errors.to_time),
                            helperText:
                              formik.touched.to_time && formik.errors.to_time,
                            onKeyDown: (e) => e.preventDefault(),
                          },
                        }}
                      />
                    </LocalizationProvider>
                  </Stack>
                  <TextField
                    name="rescheduled_reason"
                    value={formik.values.rescheduled_reason}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.rescheduled_reason &&
                      Boolean(formik.errors.rescheduled_reason)
                    }
                    rows={2}
                    multiline
                    helperText={formik.errors.rescheduled_reason}
                    fullWidth
                    label="Reschedule Reason"
                  />
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <CancelButton size="small" action={() => setOpen(false)}>
                      Cancel
                    </CancelButton>
                    <SubmitButton disabled={loading} size="small" type="submit">
                      {loading ? "Please wait..." : "Submit"}
                    </SubmitButton>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default PostSchedule;
